export const LOCAL_PURGE = 'LOCAL_PURGE';

// UI STATES
export const SET_LOCATION = 'SET_LOCATION';
export const WAS_IN = 'WAS_IN';
export const SET_UTM_INFO = 'SET_UTM_INFO';
export const SET_REFERRAL_CODE = 'SET_REFERRAL_CODE';
export const SET_SUDO_USER = 'SET_SUDO_USER';

// WS
export const WS_CONNECT_MIDDLEWARE = 'WS_CONNECT_MIDDLEWARE';
export const WS_RECONNECT_MIDDLEWARE = 'WS_RECONNECT_MIDDLEWARE';
export const WS_DISCONNECT_MIDDLEWARE = 'WS_DISCONNECT_MIDDLEWARE';
export const WS_CREATE_CONNECTION_MIDDLEWARE =
  'WS_CREATE_CONNECTION_MIDDLEWARE';

export const WS_CONNECTED_STORE = 'WS_CONNECTED_STORE';
export const WS_DISCONNECTED_STORE = 'WS_DISCONNECTED_STORE';
export const WS_TAX_SCRAPE_UPDATED_STORE = 'WS_TAX_SCRAPE_UPDATED_STORE';
export const WS_BUSINESS_NOTIFIED_STORE = 'WS_BUSINESS_NOTIFIED_STORE';

// NOTIFICACIONES
export const ENQUEUE_SNACKBAR = 'ENQUEUE_SNACKBAR';
export const CLOSE_SNACKBAR = 'CLOSE_SNACKBAR';
export const REMOVE_SNACKBAR = 'REMOVE_SNACKBAR';

// AUTH
export const LOGIN_START = 'LOGIN_START';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const LOGOUT_USER = 'LOGOUT_USER';
export const FORGOT_PASSWORD_START = 'FORGOT_PASSWORD_START';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_ERROR = 'FORGOT_PASSWORD_ERROR';
export const RESET_PASSWORD_START = 'RESET_PASSWORD_START';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR';
export const REGISTER_USER_START = 'REGISTER_USER_START';
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS';
export const REGISTER_USER_ERROR = 'REGISTER_USER_ERROR';
export const COMPLETE_REGISTER_START = 'COMPLETE_REGISTER_START';
export const COMPLETE_REGISTER_SUCCESS = 'COMPLETE_REGISTER_SUCCESS';
export const COMPLETE_REGISTER_ERROR = 'COMPLETE_REGISTER_ERROR';
export const VERIFY_EMAIL_START = 'VERIFY_EMAIL_START';
export const VERIFY_EMAIL_SUCCESS = 'VERIFY_EMAIL_SUCCESS';
export const VERIFY_EMAIL_ERROR = 'VERIFY_EMAIL_ERROR';
export const VERIFY_EMAIL_RESET = 'VERIFY_EMAIL_RESET';
export const FETCH_ENTITY_FEATURE_START = 'FETCH_ENTITY_FEATURE_START';
export const FETCH_ENTITY_FEATURE_SUCCESS = 'FETCH_ENTITY_FEATURE_SUCCESS';
export const FETCH_ENTITY_FEATURE_ERROR = 'FETCH_ENTITY_FEATURE_ERROR';

// CARDS
export const FETCH_CARDS_INFO_START = 'FETCH_CARDS_INFO_START';
export const FETCH_CARDS_INFO_ERROR = 'FETCH_CARDS_INFO_ERROR';
export const FETCH_CARDS_INFO_SUCCESS = 'FETCH_CARDS_INFO_SUCCESS';

// BUSINESS
export const FETCH_SETTINGS_RESUME_START = 'FETCH_SETTINGS_RESUME_START';
export const FETCH_SETTINGS_RESUME_ERROR = 'FETCH_SETTINGS_RESUME_ERROR';
export const FETCH_SETTINGS_RESUME_SUCCESS = 'FETCH_SETTINGS_RESUME_SUCCESS';
export const NAME_BY_IDENTIFIER_START = 'NAME_BY_IDENTIFIER_START';
export const NAME_BY_IDENTIFIER_SUCCESS = 'NAME_BY_IDENTIFIER_SUCCESS';
export const NAME_BY_IDENTIFIER_ERROR = 'NAME_BY_IDENTIFIER_ERROR';
export const NAME_BY_IDENTIFIER_RESET = 'NAME_BY_IDENTIFIER_RESET';
export const FETCH_BUSINESS_START = 'FETCH_BUSINESS_START';
export const FETCH_BUSINESS_SUCCESS = 'FETCH_BUSINESS_SUCCESS';
export const FETCH_BUSINESS_ERROR = 'FETCH_BUSINESS_ERROR';
export const UPDATE_BUSINESS_START = 'UPDATE_BUSINESS_START';
export const UPDATE_BUSINESS_SUCCESS = 'UPDATE_BUSINESS_SUCCESS';
export const UPDATE_BUSINESS_ERROR = 'UPDATE_BUSINESS_ERROR';
export const FETCH_INVOICE_DOCUMENTS_START = 'FETCH_INVOICE_DOCUMENTS_START';
export const FETCH_INVOICE_DOCUMENTS_SUCCESS =
  'FETCH_INVOICE_DOCUMENTS_SUCCESS';
export const FETCH_INVOICE_DOCUMENTS_ERROR = 'FETCH_INVOICE_DOCUMENTS_ERROR';
export const DOWNLOAD_INVOICE_DOCUMENTS_START =
  'DOWNLOAD_INVOICE_DOCUMENTS_START';
export const DOWNLOAD_INVOICE_DOCUMENTS_SUCCESS =
  'DOWNLOAD_INVOICE_DOCUMENTS_SUCCESS';
export const DOWNLOAD_INVOICE_DOCUMENTS_ERROR =
  'DOWNLOAD_INVOICE_DOCUMENTS_ERROR';

// BUSINESS BANK ACCOUNTS
export const FETCH_BUSINESS_BANK_ACCOUNTS_START =
  'FETCH_BUSINESS_BANK_ACCOUNTS_START';
export const FETCH_BUSINESS_BANK_ACCOUNTS_SUCCESS =
  'FETCH_BUSINESS_BANK_ACCOUNTS_SUCCESS';
export const FETCH_BUSINESS_BANK_ACCOUNTS_FAILURE =
  'FETCH_BUSINESS_BANK_ACCOUNTS_FAILURE';
export const CREATE_BUSINESS_BANK_ACCOUNT_START =
  'CREATE_BUSINESS_BANK_ACCOUNT_START';
export const CREATE_BUSINESS_BANK_ACCOUNT_SUCCESS =
  'CREATE_BUSINESS_BANK_ACCOUNT_SUCCESS';
export const CREATE_BUSINESS_BANK_ACCOUNT_FAILURE =
  'CREATE_BUSINESS_BANK_ACCOUNT_FAILURE';
export const UPDATE_BUSINESS_BANK_ACCOUNT_START =
  'UPDATE_BUSINESS_BANK_ACCOUNT_START';
export const UPDATE_BUSINESS_BANK_ACCOUNT_SUCCESS =
  'UPDATE_BUSINESS_BANK_ACCOUNT_SUCCESS';
export const UPDATE_BUSINESS_BANK_ACCOUNT_FAILURE =
  'UPDATE_BUSINESS_BANK_ACCOUNT_FAILURE';
export const SET_DEFAULT_BANK_ACCOUNT_START = 'SET_DEFAULT_BANK_ACCOUNT_START';
export const SET_DEFAULT_BANK_ACCOUNT_SUCCESS =
  'SET_DEFAULT_BANK_ACCOUNT_SUCCESS';
export const SET_DEFAULT_BANK_ACCOUNT_FAILURE =
  'SET_DEFAULT_BANK_ACCOUNT_FAILURE';
export const DELETE_BANK_ACCOUNT_START = 'DELETE_BANK_ACCOUNT_START';
export const DELETE_BANK_ACCOUNT_SUCCESS = 'DELETE_BANK_ACCOUNT_SUCCESS';
export const DELETE_BANK_ACCOUNT_FAILURE = 'DELETE_BANK_ACCOUNT_FAILURE';
export const BANK_ACCOUNT_RESET = 'BANK_ACCOUNT_RESET';

// TAX_SERVICE
export const CHECK_TAX_SERVICE_CREDENTIAL_START =
  'CHECK_TAX_SERVICE_CREDENTIAL_START';
export const CHECK_TAX_SERVICE_CREDENTIAL_SUCCESS =
  'CHECK_TAX_SERVICE_CREDENTIAL_SUCCESS';
export const CHECK_TAX_SERVICE_CREDENTIAL_ERROR =
  'CHECK_TAX_SERVICE_CREDENTIAL_ERROR';
export const CREATE_TAX_SERVICE_CREDENTIAL_START =
  'CREATE_TAX_SERVICE_CREDENTIAL_START';
export const CREATE_TAX_SERVICE_CREDENTIAL_SUCCESS =
  'CREATE_TAX_SERVICE_CREDENTIAL_SUCCESS';
export const CREATE_TAX_SERVICE_CREDENTIAL_ERROR =
  'CREATE_TAX_SERVICE_CREDENTIAL_ERROR';
export const CREATE_TAX_SERVICE_CREDENTIAL_RESET =
  'CREATE_TAX_SERVICE_CREDENTIAL_RESET';

// CART
export const FETCH_CART_INVOICES_SUCCESS = 'FETCH_CART_INVOICES_SUCCESS';
export const FETCH_CART_INVOICES_ERROR = 'FETCH_CART_INVOICES_ERROR';
export const FETCH_CART_INVOICES_START = 'FETCH_CART_INVOICES_START';
export const FETCH_CART_INVOICES_COUNT_SUCCESS =
  'FETCH_CART_INVOICES_COUNT_SUCCESS';
export const FETCH_CART_INVOICES_COUNT_ERROR =
  'FETCH_CART_INVOICES_COUNT_ERROR';
export const FETCH_CART_INVOICES_COUNT_START =
  'FETCH_CART_INVOICES_COUNT_START';
export const HANDLE_INVOICES_SELECTION_CHANGE =
  'HANDLE_INVOICES_SELECTION_CHANGE';
export const FETCH_CART_INVOICES_TOTAL_AMOUNT_START =
  'FETCH_CART_INVOICES_TOTAL_AMOUNT_START';
export const FETCH_CART_INVOICES_TOTAL_AMOUNT_SUCCESS =
  'FETCH_CART_INVOICES_TOTAL_AMOUNT_SUCCESS';
export const FETCH_CART_INVOICES_TOTAL_AMOUNT_ERROR =
  'FETCH_CART_INVOICES_TOTAL_AMOUNT_ERROR';
export const RESET_CART_INVOICES = 'RESET_CART_INVOICES';
export const RESET_SELECTED_INVOICES = 'RESET_SELECTED_INVOICES';
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART';
export const HANDLE_INVOICES_DATE_CHANGE = 'HANDLE_INVOICES_DATE_CHANGE';
export const CART_SIMULATE_START = 'CART_SIMULATE_START';
export const CART_SIMULATE_SUCCESS = 'CART_SIMULATE_SUCCESS';
export const SET_IS_FIRST_SIMULATION = 'SET_IS_FIRST_SIMULATION';
export const CART_SIMULATE_ERROR = 'CART_SIMULATE_ERROR';
export const ORDER_SUBMIT_START = 'ORDER_SUBMIT_START';
export const ORDER_SUBMIT_SUCCESS = 'ORDER_SUBMIT_SUCCESS';
export const ORDER_SUBMIT_ERROR = 'ORDER_SUBMIT_ERROR';

// TASKS
export const FETCH_TASKS_START = 'FETCH_TASKS_START';
export const FETCH_TASKS_ERROR = 'FETCH_TASKS_ERROR';
export const FETCH_TASKS_SUCCESS = 'FETCH_TASKS_SUCCESS';

// HOLIDAYS
export const FETCH_HOLIDAYS_START = 'FETCH_HOLIDAYS_START';
export const FETCH_HOLIDAYS_SUCCESS = 'FETCH_HOLIDAYS_SUCCESS';
export const FETCH_HOLIDAYS_ERROR = 'FETCH_HOLIDAYS_ERROR';

// ORDER
export const FETCH_ORDER_DETAIL_START = 'FETCH_ORDER_DETAIL_START';
export const FETCH_ORDER_DETAIL_SUCCESS = 'FETCH_ORDER_DETAIL_SUCCESS';
export const FETCH_ORDER_DETAIL_ERROR = 'FETCH_ORDER_DETAIL_ERROR';
export const FETCH_ORDER_INVOICES_START = 'FETCH_ORDER_INVOICES_START';
export const FETCH_ORDER_INVOICES_SUCCESS = 'FETCH_ORDER_INVOICES_SUCCESS';
export const FETCH_ORDER_INVOICES_ERROR = 'FETCH_ORDERINVOICES_ERROR';
export const RESET_ORDER_DETAILS = 'RESET_ORDER_DETAILS';

// ORDERS
export const FETCH_ORDERS_START = 'FETCH_ORDERS_START';
export const FETCH_ORDERS_SUCCESS = 'FETCH_ORDERS_SUCCESS';
export const FETCH_ORDERS_ERROR = 'FETCH_ORDERS_ERROR';

// USER
export const UPDATE_USER_START = 'UPDATE_USER_START';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_ERROR = 'UPDATE_USER_ERROR';
export const FETCH_USER_START = 'FETCH_USER_START';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_ERROR = 'FETCH_USER_ERROR';
export const UPDATE_PASSWORD_START = 'UPDATE_PASSWORD_START';
export const UPDATE_PASSWORD_SUCCESS = 'UPDATE_PASSWORD_SUCCESS';
export const UPDATE_PASSWORD_ERROR = 'UPDATE_PASSWORD_ERROR';
export const UPDATE_PASSWORD_RESET = 'UPDATE_PASSWORD_RESET';

// STAKEHOLDERS
export const FETCH_STAKEHOLDERS_START = 'FETCH_STAKEHOLDERS_START';
export const FETCH_STAKEHOLDERS_ERROR = 'FETCH_STAKEHOLDERS_ERROR';
export const FETCH_STAKEHOLDERS_SUCCESS = 'FETCH_STAKEHOLDERS_SUCCESS';
export const EDIT_STAKEHOLDERS_START = 'EDIT_STAKEHOLDERS_START';
export const EDIT_STAKEHOLDERS_ERROR = 'EDIT_STAKEHOLDERS_ERROR';
export const EDIT_STAKEHOLDERS_SUCCESS = 'EDIT_STAKEHOLDERS_SUCCESS';

// BUSINESS DOCUMENTS
export const FETCH_BUSINESS_DOCUMENT_START = 'FETCH_BUSINESS_DOCUMENT_START';
export const FETCH_BUSINESS_DOCUMENT_SUCCESS =
  'FETCH_BUSINESS_DOCUMENT_SUCCESS';
export const FETCH_BUSINESS_DOCUMENT_ERROR = 'FETCH_BUSINESS_DOCUMENT_ERROR';
export const UPLOAD_BUSINESS_DOCUMENT_START = 'UPLOAD_BUSINESS_DOCUMENT_START';
export const UPLOAD_BUSINESS_DOCUMENT_SUCCESS =
  'UPLOAD_BUSINESS_DOCUMENT_SUCCESS';
export const UPLOAD_BUSINESS_DOCUMENT_ERROR = 'UPLOAD_BUSINESS_DOCUMENT_ERROR';
export const DOWNLOAD_BUSINESS_DOCUMENT_START =
  'DOWNLOAD_BUSINESS_DOCUMENT_START';
export const DOWNLOAD_BUSINESS_DOCUMENT_SUCCESS =
  'DOWNLOAD_BUSINESS_DOCUMENT_SUCCESS';
export const DOWNLOAD_BUSINESS_DOCUMENT_ERROR =
  'DOWNLOAD_BUSINESS_DOCUMENT_ERROR';

// BANKS
export const FETCH_BANKS_START = 'FETCH_BANKS_START';
export const FETCH_BANKS_SUCCESS = 'FETCH_BANKS_SUCCESS';
export const FETCH_BANKS_FAILURE = 'FETCH_BANKS_FAILURE';

// DOCUMENT
export const FETCH_DOCUMENT_START = 'FETCH_DOCUMENT_START';
export const FETCH_DOCUMENT_SUCCESS = 'FETCH_DOCUMENT_SUCCESS';
export const FETCH_DOCUMENT_ERROR = 'FETCH_DOCUMENT_ERROR';
export const UPLOAD_DOCUMENT_START = 'UPLOAD_DOCUMENT_START';
export const UPLOAD_DOCUMENT_SUCCESS = 'UPLOAD_DOCUMENT_SUCCESS';
export const UPLOAD_DOCUMENT_ERROR = 'UPLOAD_DOCUMENT_ERROR';
export const DOWNLOAD_DOCUMENT_START = 'DOWNLOAD_DOCUMENT_START';
export const DOWNLOAD_DOCUMENT_SUCCESS = 'DOWNLOAD_DOCUMENT_SUCCESS';
export const DOWNLOAD_DOCUMENT_ERROR = 'DOWNLOAD_DOCUMENT_ERROR';
export const VERIFY_DOCUMENTS_START = 'VERIFY_DOCUMENTS_START';
export const VERIFY_DOCUMENTS_SUCCESS = 'VERIFY_DOCUMENTS_SUCCESS';
export const VERIFY_DOCUMENTS_FAILURE = 'VERIFY_DOCUMENTS_FAILURE';
export const VERIFY_DOCUMENTS_RESET = 'VERIFY_DOCUMENTS_RESET';

// GEO
export const FETCH_GEO_MX_STATES_START = 'FETCH_GEO_MX_STATES_START';
export const FETCH_GEO_MX_STATES_SUCCESS = 'FETCH_GEO_MX_STATES_SUCCESS';
export const FETCH_GEO_MX_STATES_FAILURE = 'FETCH_GEO_MX_STATES_FAILURE';
export const FETCH_GEO_MX_MUNICIPALITY_START =
  'FETCH_GEO_MX_MUNICIPALITY_START';
export const FETCH_GEO_MX_MUNICIPALITY_SUCCESS =
  'FETCH_GEO_MX_MUNICIPALITY_SUCCESS';
export const FETCH_GEO_MX_MUNICIPALITY_FAILURE =
  'FETCH_GEO_MX_MUNICIPALITY_FAILURE';
export const FETCH_GEO_MX_COLONY_START = 'FETCH_GEO_MX_COLONY_START';
export const FETCH_GEO_MX_COLONY_SUCCESS = 'FETCH_GEO_MX_COLONY_SUCCESS';
export const FETCH_GEO_MX_COLONY_FAILURE = 'FETCH_GEO_MX_COLONY_FAILURE';

// DEBT SERVICE
export const FETCH_DEBT_SERVICE_START = 'FETCH_DEBT_SERVICE_START';
export const FETCH_DEBT_SERVICE_SUCCESS = 'FETCH_DEBT_SERVICE_SUCCESS';
export const FETCH_DEBT_SERVICE_FAILURE = 'FETCH_DEBT_SERVICE_FAILURE';

// PAYMENTS

export const PAYMENTS_SET_ACTIVE_TAB = 'PAYMENTS_SET_ACTIVE_TAB';
export const PAYMENTS_HANDLE_INVOICES_SELECTION_CHANGE =
  'PAYMENTS_HANDLE_INVOICES_SELECTION_CHANGE';
export const PAYMENTS_CLEAR_INVOICES_SELECTION_CHANGE =
  'PAYMENTS_CLEAR_INVOICES_SELECTION_CHANGE';
export const PAYMENTS_TOGGLE_LOADING_TABLE = 'PAYMENTS_TOGGLE_LOADING_TABLE';
export const PAYMENTS_SET_PAGINATION = 'PAYMENTS_SET_PAGINATION';

export const FETCH_PAYMENTS_INVOICES_START = 'FETCH_PAYMENTS_INVOICES_START';
export const FETCH_PAYMENTS_INVOICES_SUCCESS =
  'FETCH_PAYMENTS_INVOICES_SUCCESS';
export const FETCH_PAYMENTS_INVOICES_ERROR = 'FETCH_PAYMENTS_INVOICES_ERROR';

export const ARCHIVE_PAYMENTS_INVOICES_START =
  'ARCHIVE_PAYMENTS_INVOICES_START';
export const ARCHIVE_PAYMENTS_INVOICES_SUCCESS =
  'ARCHIVE_PAYMENTS_INVOICES_SUCCESS';
export const ARCHIVE_PAYMENTS_INVOICES_ERROR =
  'ARCHIVE_PAYMENTS_INVOICES_ERROR';

export const PAY_PAYMENTS_INVOICES_START = 'PAY_PAYMENTS_INVOICES_START';
export const PAY_PAYMENTS_INVOICES_SUCCESS = 'PAY_PAYMENTS_INVOICES_SUCCESS';
export const PAY_PAYMENTS_INVOICES_ERROR = 'PAY_PAYMENTS_INVOICES_ERROR';

export const RESTORE_PAYMENTS_INVOICES_START =
  'RESTORE_PAYMENTS_INVOICES_START';
export const RESTORE_PAYMENTS_INVOICES_ERROR =
  'RESTORE_PAYMENTS_INVOICES_ERROR';

export const FETCH_PAYMENTS_STATS_START = 'FETCH_PAYMENTS_STATS_START';
export const FETCH_PAYMENTS_STATS_SUCCESS = 'FETCH_PAYMENTS_STATS_SUCCESS';
export const FETCH_PAYMENTS_STATS_ERROR = 'FETCH_PAYMENTS_STATS_ERROR';

export const CHANGE_PAYMENT_DATE_PAYMENTS_START =
  'CHANGE_PAYMENT_DATE_PAYMENTS_START';
export const CHANGE_PAYMENT_DATE_PAYMENTS_ERROR =
  'CHANGE_PAYMENT_DATE_PAYMENTS_ERROR';
export const FETCH_SUPPLIERS_START = 'FETCH_SUPPLIERS_START';
export const FETCH_SUPPLIERS_SUCCESS = 'FETCH_SUPPLIERS_SUCCESS';
export const FETCH_SUPPLIERS_ERROR = 'FETCH_SUPPLIERS_ERROR';
export const UPDATE_SUPPLIER_START = 'UPDATE_SUPPLIERS_START';
export const UPDATE_SUPPLIER_SUCCESS = 'UPDATE_SUPPLIERS_SUCCESS';
export const UPDATE_SUPPLIER_ERROR = 'UPDATE_SUPPLIERS_ERROR';
export const SET_SUPPLIER = 'SET_SUPPLIER';

export const SAVE_PAYROLL_START = 'SAVE_PAYROLL_START';
export const SAVE_PAYROLL_SUCCESS = 'SAVE_PAYROLL_SUCCESS';
export const SAVE_PAYROLL_FAILURE = 'SAVE_PAYROLL_FAILURE';

// BANK ACCOUNTS
export const CREATE_BANK_ACCOUNT_FAILURE = 'CREATE_BANK_ACCOUNT_FAILURE';
export const CREATE_BANK_ACCOUNT_START = 'CREATE_BANK_ACCOUNT_START';
export const CREATE_BANK_ACCOUNT_SUCCESS = 'CREATE_BANK_ACCOUNT_SUCCESS';
export const FETCH_BANK_ACCOUNTS_FAILURE = 'FETCH_BANK_ACCOUNTS_FAILURE';
export const FETCH_BANK_ACCOUNTS_START = 'FETCH_BANK_ACCOUNTS_START';
export const FETCH_BANK_ACCOUNTS_SUCCESS = 'FETCH_BANK_ACCOUNTS_SUCCESS';
export const GENERIC_BANK_ACCOUNT_RESET = 'GENERIC_BANK_ACCOUNT_RESET';
export const GENERIC_DELETE_BANK_ACCOUNT_FAILURE =
  'GENERIC_DELETE_BANK_ACCOUNT_FAILURE';
export const GENERIC_DELETE_BANK_ACCOUNT_START =
  'GENERIC_DELETE_BANK_ACCOUNT_START';
export const GENERIC_DELETE_BANK_ACCOUNT_SUCCESS =
  'GENERIC_DELETE_BANK_ACCOUNT_SUCCESS';
export const GENERIC_FETCH_BANKS_FAILURE = 'GENERIC_FETCH_BANKS_FAILURE';
export const GENERIC_FETCH_BANKS_START = 'GENERIC_FETCH_BANKS_START';
export const GENERIC_FETCH_BANKS_SUCCESS = 'GENERIC_FETCH_BANKS_SUCCESS';
export const GENERIC_SET_DEFAULT_BANK_ACCOUNT_FAILURE =
  'GENERIC_SET_DEFAULT_BANK_ACCOUNT_FAILURE';
export const GENERIC_SET_DEFAULT_BANK_ACCOUNT_START =
  'GENERIC_SET_DEFAULT_BANK_ACCOUNT_START';
export const GENERIC_SET_DEFAULT_BANK_ACCOUNT_SUCCESS =
  'GENERIC_SET_DEFAULT_BANK_ACCOUNT_SUCCESS';
export const UPDATE_BANK_ACCOUNT_FAILURE = 'UPDATE_BANK_ACCOUNT_FAILURE';
export const UPDATE_BANK_ACCOUNT_START = 'UPDATE_BANK_ACCOUNT_START';
export const UPDATE_BANK_ACCOUNT_SUCCESS = 'UPDATE_BANK_ACCOUNT_SUCCESS';
export const BANK_ACCOUNT_CLEANUP = 'BANK_ACCOUNT_CLEANUP';
export const SET_BANK_ACCOUNT_SOURCE = 'SET_BANK_ACCOUNT_SOURCE';

// PAYROLL
export const CREATE_PAYROLL_FAILURE = 'CREATE_PAYROLL_FAILURE';
export const CREATE_PAYROLL_START = 'CREATE_PAYROLL_START';
export const CREATE_PAYROLL_SUCCESS = 'CREATE_PAYROLL_SUCCESS';
export const DELETE_PAYROLL_FAILURE = 'DELETE_PAYROLL_FAILURE';
export const DELETE_PAYROLL_START = 'DELETE_PAYROLL_START';
export const DELETE_PAYROLL_SUCCESS = 'DELETE_PAYROLL_SUCCESS';
export const FETCH_PAYROLL_FAILURE = 'FETCH_PAYROLL_FAILURE';
export const FETCH_PAYROLL_START = 'FETCH_PAYROLL_START';
export const FETCH_PAYROLL_SUCCESS = 'FETCH_PAYROLL_SUCCESS';
export const FETCH_PAYROLLS_FAILURE = 'FETCH_PAYROLLS_FAILURE';
export const FETCH_PAYROLLS_START = 'FETCH_PAYROLLS_START';
export const FETCH_PAYROLLS_SUCCESS = 'FETCH_PAYROLLS_SUCCESS';
export const UPDATE_PAYROLL_FAILURE = 'UPDATE_PAYROLL_FAILURE';
export const UPDATE_PAYROLL_START = 'UPDATE_PAYROLL_START';
export const UPDATE_PAYROLL_SUCCESS = 'UPDATE_PAYROLL_SUCCESS';
export const RESET_PAYROLLS = 'RESET_PAYROLLS';
export const PAY_PAYROLL_START = 'PAY_PAYROLL_START';
export const PAY_PAYROLL_SUCCESS = 'PAY_PAYROLL_SUCCESS';
export const PAY_PAYROLL_FAILURE = 'PAY_PAYROLL_FAILURE';
export const FINANCING_PAYROLL_START = 'FINANCING_PAYROLL_START';
export const FINANCING_PAYROLL_SUCCESS = 'FINANCING_PAYROLL_SUCCESS';
export const FINANCING_PAYROLL_FAILURE = 'FINANCING_PAYROLL_FAILURE';
export const RESET_FINANCING = 'RESET_FINANCING';

// CONTACT DETAIL
export const CONTACT_DETAIL_CLEANUP = 'CONTACT_DETAIL_CLEANUP';
export const CONTACT_DETAIL_RESET = 'CONTACT_DETAIL_RESET';
export const CREATE_CONTACT_DETAIL_FAILURE = 'CREATE_CONTACT_DETAIL_FAILURE';
export const CREATE_CONTACT_DETAIL_START = 'CREATE_CONTACT_DETAIL_START';
export const CREATE_CONTACT_DETAIL_SUCCESS = 'CREATE_CONTACT_DETAIL_SUCCESS';
export const DELETE_CONTACT_DETAIL_FAILURE = 'DELETE_CONTACT_DETAIL_FAILURE';
export const DELETE_CONTACT_DETAIL_START = 'DELETE_CONTACT_DETAIL_START';
export const DELETE_CONTACT_DETAIL_SUCCESS = 'DELETE_CONTACT_DETAIL_SUCCESS';
export const FETCH_CONTACT_DETAIL_FAILURE = 'FETCH_CONTACT_DETAIL_FAILURE';
export const FETCH_CONTACT_DETAIL_START = 'FETCH_CONTACT_DETAIL_START';
export const FETCH_CONTACT_DETAIL_SUCCESS = 'FETCH_CONTACT_DETAIL_SUCCESS';
export const UPDATE_CONTACT_DETAIL_FAILURE = 'UPDATE_CONTACT_DETAIL_FAILURE';
export const UPDATE_CONTACT_DETAIL_START = 'UPDATE_CONTACT_DETAIL_START';
export const UPDATE_CONTACT_DETAIL_SUCCESS = 'UPDATE_CONTACT_DETAIL_SUCCESS';

// PAYMENT DOCUMENTS

export const UPLOAD_VOUCHER_START = 'UPLOAD_VOUCHER_START';
export const UPLOAD_VOUCHER_SUCCESS = 'UPLOAD_VOUCHER_SUCCESS';
export const UPLOAD_VOUCHER_FAILURE = 'UPLOAD_VOUCHER_FAILURE';

export const LOAD_DOCUMENT_START = 'LOAD_DOCUMENT_START';
export const LOAD_DOCUMENT_SUCCESS = 'LOAD_DOCUMENT_SUCCESS';
export const LOAD_DOCUMENT_FAILURE = 'LOAD_DOCUMENT_FAILURE';

// ONBOARD

export const FETCH_ONBOARD_START = 'FETCH_ONBOARD_START';
export const FETCH_ONBOARD_SUCCESS = 'FETCH_ONBOARD_SUCCESS';
export const FETCH_ONBOARD_FAILURE = 'FETCH_ONBOARD_FAILURE';

export const FETCH_ONBOARD_SUPPLIERS_START = 'FETCH_ONBOARD_SUPPLIERS_START';
export const FETCH_ONBOARD_SUPPLIERS_SUCCESS =
  'FETCH_ONBOARD_SUPPLIERS_SUCCESS';
export const FETCH_ONBOARD_SUPPLIERS_FAILURE =
  'FETCH_ONBOARD_SUPPLIERS_FAILURE';

export const SAVE_ONBOARD_START = 'SAVE_ONBOARD_START';
export const SAVE_ONBOARD_SUCCESS = 'SAVE_ONBOARD_SUCCESS';
export const SAVE_ONBOARD_FAILURE = 'SAVE_ONBOARD_FAILURE';
export const RESET_ONBOARD = 'RESET_ONBOARD';
